import { ImgProps } from "assets/images/types";

export default function ImgNaturaHomemMain(props: ImgProps) {
	const { height = 260, width = 516 } = props;
	return (
		<img
			src="/assets/images/cases/natura-homem-nos/natura-homem-nos-card.webp"
			alt="Endrick em Natura Homem Nós"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
